import {CreatePlaylistSchema} from "@repo/shared";

import {functionHookFactory} from "../factories/functionHookFactory";

export const useCreatePlaylist = functionHookFactory(
  "createPlaylist",
  CreatePlaylistSchema,
);
